import classnames from "classnames";
import styles from "./StickyTable.module.scss";

export function StickyTable({ column = 1, children, ...props }) {
    return (
        <table className={classnames(styles.table, { [styles.column2]: column > 1 })} {...props}>
            {children}
        </table>
    );
}
